/* LinksRenderer.js */

"use strict";
const Registrations = require("../../../../../../../RegistrationNamespaces");
const _ = require("lodash");

class LinksRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("links-column");
        this._rootElem.component = this._model;
        this._executionLogIcon = document.createElement("actionable-icon-gl");
        this._executionLogIcon.dataset.icon = "common.log_link";
        this._executionLogIcon.setAttribute("title", "Logs");
        this._registerListeners();
        this.render();
    }

    /* ******************************************
    /* START PRIVATE COMPONENT RENDERER METHODS
    /* ****************************************** */
    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._executionLogIcon.remove();
            this._executionLogIcon = undefined;
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._executionLogIcon.addEventListener(
            "click",
            (this._onClickLogIcon = this._onClickLogIcon.bind(this))
        );
        this._model.on("Links", (this._onLinks = this._onLinks.bind(this)));
    }

    _unregisterListeners() {
        this._executionLogIcon.removeEventListener("click", this._onClickLogIcon);
        this._model.removeAllListeners("Links");
    }

    /** navigate inside view tab */
    _switchView(switchTo, params) {
        const _params = Object.assign(
            {},
            {
                configExecutionEntity: this._model.getValue(),
                customFieldsEntityDef: _.get(
                    this._model,
                    "_parentModel._customFieldsEntityDef",
                    {}
                ),
                deviceEntityDef: _.get(this._model, "_parentModel._deviceEntityDef", {}),
            },
            params
        );
        this._model._gameEditor.setActiveView(
            switchTo,
            [
                {
                    value: {
                        fqn: Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_HISTORY,
                        viewState: {
                            configExecutionEntity: _params.configExecutionEntity,
                        },
                    },
                    content: "Network Discovery Execution Summary",
                    left: {
                        arrow: {
                            direction: "left",
                        },
                    },
                },
            ],
            _params
        );
    }

    _onClickLogIcon() {
        this._switchView(Registrations.NETWORK_DISCOVERY_EDITOR_SUBVIEW_EXECUTION_LOG);
    }

    /* *****************************************
    /* END PRIVATE COMPONENT RENDERER METHODS
    /* START PUBLIC COMPONENT RENDERER METHODS
    /* ***************************************** */
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */

    render() {
        this._setLinks(this._model.getLinks());
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* *****************************************
    /* END COMPONENT RENDERER METHODS
    /* START HANDLER METHODS
    /* ***************************************** */

    _onLinks(newVal) {
        this._setLinks(newVal);
    }

    /* *****************************************
    /* END HANDLER METHODS
    /* START PRIVATE API METHODS
    /* ***************************************** */

    _setLinks() {
        this._rootElem.innerHTML = "";
        this._rootElem.appendChild(this._executionLogIcon);
    }

    _hideViewActions() {}
    _showViewActions() {}
    _refreshGrid() {}
    _hideLeftFooterContainer() {}
    _showLeftFooterContainer() {}

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = LinksRenderer;
